import React from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';
import { parse, stringify } from 'query-string';

import App from '~/App';
import { AceService, BridgeService, TokenService } from '~/services';
import { isReactNativeAceWebView, LOCALE_CHINESE } from '~/helpers';

import '~/helpers/la';

const {
  NODE_ENV,
  REACT_APP_LOGGER_ENDPOINT,
  REACT_APP_MS_LANDING_ENDPOINT,
  REACT_APP_VERSION,
} = process.env;

const startAppForBrowser = (tokens) => {
  if (!tokens) {
    if (NODE_ENV === 'development') {
      AceService.signIn();
    } else {
      const search = parse(window.location.search);
      const locale = search.locale || LOCALE_CHINESE;

      window.location.href = `${REACT_APP_MS_LANDING_ENDPOINT}?${stringify({
        locale,
      })}`;
    }

    return;
  }

  const renderApp = () =>
    ReactDOM.render(<App />, document.getElementById('root'));

  if (NODE_ENV === 'development') {
    renderApp();
  } else {
    Raven.config(REACT_APP_LOGGER_ENDPOINT, {
      release: REACT_APP_VERSION,
    }).install();
    Raven.context(renderApp);
  }
};

const startAppForWebView = async (tokens) => {
  const { origin, pathname, search } = window.location;

  if (search) {
    window.history.replaceState({}, document.title, `${origin}${pathname}`);
  }

  BridgeService.setAppVersion();

  if (!tokens) {
    const authTokens = await AceService.getAuthTokens();

    if (!authTokens) {
      BridgeService.setAuthTokens();
    }

    return;
  }

  const isTokenElevated = TokenService.isTokenElevated(tokens.id_token);
  const postTokensMethod = isTokenElevated
    ? 'setElevateTokens'
    : 'setAuthTokens';

  BridgeService[postTokensMethod](tokens);
};

AceService.authorize().then((tokens) => {
  if (isReactNativeAceWebView) {
    startAppForWebView(tokens);
  } else {
    startAppForBrowser(tokens);
  }
});
